export class ImpressionRapport {
  constructor (impressionRapport) {
    this.pageName = impressionRapport ? impressionRapport.pageName : null
    this.selectedCardId = impressionRapport ? impressionRapport.selectedCardId : null
    this.selectedPeriode = impressionRapport ? impressionRapport.selectedPeriode : null
    this.selectedEntreprise = impressionRapport ? impressionRapport.selectedEntreprise : null
    this.loggedUserLogin = impressionRapport ? impressionRapport.loggedUserLogin : null
    this.selectedPorteurId = impressionRapport ? impressionRapport.selectedPorteurId : null
    this.adminRechercheOperationsParameters = impressionRapport ? impressionRapport.adminRechercheOperationsParameters : null
  }
}
